import CircularSlider from '@fseehawer/react-circular-slider';
import { Overlay, OptionContainer, Row, RowLang, Column, CogIcon, OptionHeader, OptionTitle, RowBtns } from './style';
import { useState, useEffect } from 'react';
import { Cog } from '@styled-icons/boxicons-solid'
import Switch from 'react-switch'
import ReactFlagsSelect from 'react-flags-select';
import Button from '../generalButton/index.jsx';

export default (props) => {
    const { closeFn, updateParent } = props;
    const [backgroundSFXEnabled, setBackgroundSFXEnabled] = useState(window.backgroundSFX.playingEnabled);
    const [backgroundSFXVolume, setBackgroundSFXVolume] = useState(window.backgroundSFX.volume);
    const [soundSFXEnabled, setSoundSFXEnabled] = useState(window.soundSFX.playingEnabled);
    const [soundSFXVolume, setSoundSFXVolume] = useState(window.soundSFX.volume);
    const [ttsDialogue, setTTSDialogue] = useState(window.ttsDialogue.playingEnabled);
    const [ttsDialogueVolume, setTTSDialogueVolume] = useState(window.ttsDialogue.volume);
    const [selected, setSelected] = useState(window.rs ? 'RS' : 'GB');

    return (
        <Overlay>
            <OptionContainer>
                <Row>
                    <Cog style={CogIcon} />
                    <OptionHeader>{window.rs ? 'Preference' : 'Preferences'}</OptionHeader>
                </Row>
                <RowLang>
                    <Column>
                        <OptionTitle>{window.rs ? 'Jezik' : 'Language'}</OptionTitle>
                    </Column>
                    <Column>
                        <ReactFlagsSelect
                            countries={['GB', 'RS']}
                            customLabels={{
                                'GB': 'English',
                                'RS': 'Srpski'
                            }}
                            selected={selected}
                            onSelect={code => setSelected(code)}
                            fullWidth={false} />
                    </Column>
                </RowLang>
                <Row>
                    <Column>
                        <Row>
                            <Column>
                                <OptionTitle>{window.rs ? 'Muzika' : 'Music' }</OptionTitle>
                            </Column>
                            <Column>
                                <Switch 
                                    onChange={() => {
                                        setBackgroundSFXEnabled(!backgroundSFXEnabled)
                                    }} 
                                    checked={backgroundSFXEnabled} />
                            </Column>
                        </Row>
                        <Row>
                            <CircularSlider
                                min={0}
                                max={100}
                                dataIndex={window.backgroundSFX.volume * 100}
                                width={125}
                                direction={1}
                                knobPosition="top"
                                valueFontSize="2rem"
                                trackColor="#eeeeee"
                                progressColorFrom={"#00bfbd"}
                                progressColorTo={"#009c9a"}
                                labelColor={"#00bfbd"}
                                knobColor={"#00bfbd"}
                                label={window.rs ? 'Glasnoća' : 'Volume'}
                                trackSize={0}
                                progressSize={5}
                                knobSize={25}
                                onChange={ value => {
                                    setBackgroundSFXVolume(value);
                                }}
                            />
                        </Row>
                    </Column>
                    <Column>
                        <Row>
                            <Column>
                                <OptionTitle>{window.rs ? 'Zvučni Efekti' : 'Sound effects' }</OptionTitle>
                            </Column>
                            <Column>
                            <Switch 
                                onChange={() => {
                                    setSoundSFXEnabled(!soundSFXEnabled)
                                }} 
                                checked={soundSFXEnabled} />
                            </Column>
                        </Row>
                        <Row>
                        <CircularSlider
                            min={0}
                            max={100}
                            dataIndex={window.soundSFX.volume * 100}
                            width={125}
                            direction={1}
                            knobPosition="top"
                            valueFontSize="2rem"
                            trackColor="#eeeeee"
                            progressColorFrom={"#00bfbd"}
                            progressColorTo={"#009c9a"}
                            labelColor={"#00bfbd"}
                            knobColor={"#00bfbd"}
                            label={window.rs ? 'Glasnoća' : 'Volume'}
                            trackSize={0}
                            progressSize={5}
                            knobSize={25}
                            onChange={ value => {
                                setSoundSFXVolume(value);
                            }}
                        />
                        </Row>     
                    </Column>
                    <Column>
                        { !window.rs && <>
                            <Row>
                                <Column>
                                    <OptionTitle>Janky TTS dialogue</OptionTitle>
                                </Column>
                                <Column>
                                    <Switch 
                                        onChange={() => {
                                            setTTSDialogue(!ttsDialogue)
                                        }} 
                                        checked={ttsDialogue} />
                                </Column>
                            </Row>
                            <Row>
                                <CircularSlider
                                    min={0}
                                    max={100}
                                    dataIndex={window.ttsDialogue.volume * 100}
                                    width={125}
                                    direction={1}
                                    knobPosition="top"
                                    valueFontSize="2rem"
                                    trackColor="#eeeeee"
                                    progressColorFrom={"#00bfbd"}
                                    progressColorTo={"#009c9a"}
                                    labelColor={"#00bfbd"}
                                    knobColor={"#00bfbd"}
                                    label={window.rs ? 'Glasnoća' : 'Volume'}
                                    trackSize={0}
                                    progressSize={5}
                                    knobSize={25}
                                    onChange={ value => {
                                        setTTSDialogueVolume(value);
                                    }}
                                />
                            </Row>
                        </> }
                    </Column>
                </Row>
                <hr />
                <Row>
                    <Column></Column>
                    <Column>
                        <RowBtns>
                            <Button
                                txt={window.rs ? 'Sačuvaj' : 'Save'} 
                                buttonAction={() => {
                                    window.backgroundSFX.volume !== (backgroundSFXVolume / 100) ? window.backgroundSFX.volume = backgroundSFXVolume / 100 : null;   
                                    window.backgroundSFX.playingEnabled !== backgroundSFXEnabled ? window.backgroundSFX.playingEnabled = backgroundSFXEnabled : null;
                                    window.backgroundSFX.playingEnabled ? window.backgroundSFX.play() : window.backgroundSFX.pause();

                                    window.soundSFX.volume !== (soundSFXVolume / 100) ? window.soundSFX.volume = soundSFXVolume / 100 : null;
                                    window.soundSFX.playingEnabled !== soundSFXEnabled ? window.soundSFX.playingEnabled = soundSFXEnabled : null;

                                    if(window.ttsDialogue.volume !== ttsDialogueVolume) {
                                        window.ttsDialogue.volume !== (ttsDialogueVolume / 100) ? window.ttsDialogue.volume = ttsDialogueVolume / 100 : null;
                                        window.ttsDialogue.playingEnabled !== ttsDialogue ? window.ttsDialogue.playingEnabled = ttsDialogue : null;
                                    }

                                    selected === 'GB' ? window.rs = false : window.rs = true;

                                    closeFn(false)
                                    updateParent(window.backgroundSFX.playingEnabled)
                                }}
                                leftGradiant={'rgb(65, 105, 225)'}
                                rightGradiant={'rgb(135, 206, 235)'}
                                triangleHeight={'40px'}
                                markerHeight={'40px'}
                                sizeFont={'1rem'}
                                markerDeg={'32deg'}
                            />
                            <Button
                                txt={window.rs ? 'Otkaži' : 'Cancel'} 
                                buttonAction={() => {
                                    closeFn(false)
                                }}
                                leftGradiant={'rgb(65, 105, 225)'}
                                rightGradiant={'rgb(135, 206, 235)'}
                                triangleHeight={'40px'}
                                markerHeight={'40px'}
                                sizeFont={'1rem'}
                                markerDeg={'32deg'}
                            />
                        </RowBtns>
                    </Column>
                </Row>
            </OptionContainer>
        </Overlay>
    )
}
